<lib-personality-backdrop />
<div class="container">
  <div class="motion-background">
    <otui-personality-scene
      height="24rem"
      fallbackScene="topographic-drift"
      [density]="8"
      [speed]="1.4"
      [intensity]="0.64"
    ></otui-personality-scene>
  </div>

  <otui-app-bar
    appTitle="Video Platform"
    logoSrc="android-chrome-192x192.png"
    logoAlt="Video Platform Logo"
    [showThemeToggle]="true"
    [useTile]="false"
    (menuToggle)="toggleNav()"
  >
  </otui-app-bar>

  <otui-nav-sidebar
    [isOpen]="isNavExpanded()"
    [navItems]="navItems()"
    heading="Navigation"
    (close)="isNavExpanded.set(false)"
  >
  </otui-nav-sidebar>

  <div class="content">
    <router-outlet />
  </div>

  <hai-about-tag [config]="haiAboutConfig"></hai-about-tag>
</div>
